import React, { memo } from "react";
import AerosNode, { OptionList, OptionRow } from "./AerosNode";

// ids das alças ficam "a"+number: o backend resolve a opção do menu por sourceHandle.
export default memo(({ data, id, isConnectable, selected }) => (
  <AerosNode
    id={id}
    type="menu"
    selected={selected}
    isConnectable={isConnectable}
    hasSource={false}
    options={
      <OptionList>
        {(data.arrayOption || []).map((option) => (
          <OptionRow
            key={option.number}
            badge={option.number}
            label={option.value}
            tone="msg"
            handleId={"a" + option.number}
            isConnectable={isConnectable}
          />
        ))}
      </OptionList>
    }
  >
    {data.message}
  </AerosNode>
));
